// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeyCarStaticFinance_wrapper__MsbeH","title":"HeyCarStaticFinance_title__foWLZ"};